import { yCursorPlugin } from 'y-prosemirror';
import { Awareness } from 'y-protocols/awareness';

import { UserAwareness } from '../Editor/types';

export const getCursorElement = (userId: string) =>
  document.querySelector(`[data-cursor-id="${userId}"]`);

export const defaultCursorBuilder = (user: UserAwareness) => {
  const cursor = document.createElement('span');
  cursor.setAttribute('data-cursor-id', user.id);
  cursor.classList.add('ProseMirror-yjs-cursor');
  cursor.setAttribute('style', `border-color: ${user.color};`);

  let divStyle = `background-color: ${user.color};`;
  if (user.textColor) {
    divStyle += `color: ${user.textColor};`;
  }

  const cursorHandle = document.createElement('div');
  cursorHandle.classList.add('cursor-handle');
  cursorHandle.setAttribute('style', divStyle);
  cursor.insertBefore(cursorHandle, null);

  const userDiv = document.createElement('div');
  userDiv.classList.add('cursor-name');
  userDiv.setAttribute('style', divStyle);

  userDiv.insertBefore(document.createTextNode(user.name), null);
  cursor.insertBefore(userDiv, null);
  return cursor;
};

const cursorPlugin = (awareness: Awareness) =>
  // @ts-ignore
  yCursorPlugin(awareness, { cursorBuilder: defaultCursorBuilder });

export default cursorPlugin;
